import { render, staticRenderFns } from "./TicketEstimate.vue?vue&type=template&id=3c4e7be6&scoped=true&"
import script from "./TicketEstimate.vue?vue&type=script&lang=ts&"
export * from "./TicketEstimate.vue?vue&type=script&lang=ts&"
import style0 from "./TicketEstimate.vue?vue&type=style&index=0&id=3c4e7be6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e7be6",
  null
  
)

export default component.exports